var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLevel4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7489 19.8373C18.9051 20.0137 19 20.2458 19 20.5V26.1566C19 27.2294 18.0948 28 17.1051 28H7.89489C6.90369 28 6 27.2288 6 26.1566V5.84343C6 4.77123 6.90369 4 7.89489 4H17.1051C18.0948 4 19 4.7706 19 5.84343V11.5894L24.0069 9.10427C24.4924 8.86328 25.0815 9.05298 25.3352 9.53199L26.8837 11.456C27.0978 11.8603 27.0103 12.3583 26.6711 12.6654L18.7489 19.8373ZM10 7C10.5523 7 11 7.44772 11 8V11C11 11.5523 10.5523 12 10 12C9.44772 12 9 11.5523 9 11V8C9 7.44772 9.44772 7 10 7ZM11.2183 16.3798C11.2185 16.3794 11.2184 16.3796 11.218 16.3805L11.214 16.391C11.2091 16.4038 11.2005 16.4273 11.1894 16.4602C11.1672 16.5263 11.1356 16.629 11.1045 16.7598C11.0417 17.0247 10.9856 17.3858 11.0033 17.7821C11.037 18.5335 11.3269 19.4426 12.5077 20.1385C12.9835 20.4189 13.1419 21.0319 12.8615 21.5077C12.5811 21.9835 11.9681 22.1419 11.4923 21.8615C9.62699 20.7623 9.06352 19.1714 9.00533 17.8716C8.97715 17.2422 9.06554 16.69 9.15861 16.2979C9.20554 16.1002 9.25479 15.9384 9.2939 15.8222C9.3135 15.764 9.33067 15.7168 9.34392 15.6819C9.35055 15.6644 9.35621 15.65 9.36071 15.6387L9.36659 15.6241L9.36883 15.6186L9.36978 15.6164L9.3702 15.6153C9.3704 15.6149 9.3706 15.6144 10.2857 15.9968L9.3706 15.6144C9.58356 15.1048 10.1693 14.8644 10.6789 15.0773C11.1866 15.2895 11.4271 15.8718 11.2182 16.3801L11.2183 16.3798Z",
    fill: "#E4803A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4756 27.7759H4.01465",
    stroke: "#E4803A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel4);
export default __webpack_public_path__ + "static/media/Level4.f5b986f48651ffbeba294ccc01334d6b.svg";
export { ForwardRef as ReactComponent };